import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export function NoPermission({ role }) {
  const navigate = useNavigate();

  const redirectUri = (()=>{
    switch(role){
      case "employee":
        return "/tasks";
      default:
        return "/";
    }
  })()
  return (
    <Result
      status="403"
      title="Permission not allowed"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button type="primary" onClick={() => navigate(redirectUri)}>
          Back Home
        </Button>
      }
    />
  );
}
